import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import ClipLoader from "react-spinners/ClipLoader";
import { Button } from "hesus-ui-kit";
import {
  BannerContainer,
  ValidationWrapper,
  ButtonWrapper,
} from "./SiteValidationBanner.styled";

const SiteValidationBanner = (props) => {
  const { t, validateBanner, isSiteValidateLoaderVisible } = props;

  return (
    <BannerContainer>
      <ValidationWrapper>
        <ButtonWrapper>
          {!isSiteValidateLoaderVisible && (
            <Button
              onClick={validateBanner}
              styles={{
                color: "white",
                background: "green",
                border: "1px solid green",
                marginRight: "0.32rem",
                "&:hover": {
                  backgroundColor: "green",
                },
              }}
            >
              {t("KICK_OFF_PAGE_SITE_INFORMATIONS_BUTTON_VALIDATE")}
            </Button>
          )}
          {isSiteValidateLoaderVisible && (
            <ClipLoader size={20} color="#1bace4" />
          )}
        </ButtonWrapper>
      </ValidationWrapper>
    </BannerContainer>
  );
};

SiteValidationBanner.propTypes = {
  t: PropTypes.func.isRequired,
  isSiteValidateLoaderVisible: PropTypes.bool,
  validateBanner: PropTypes.func.isRequired,
};
SiteValidationBanner.defaultProps = {
  isSiteValidateLoaderVisible: false,
};

export default withTranslation()(SiteValidationBanner);
